import { FunctionComponent, useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import { campaignController } from '@/apis/core';
import { Loader } from '@/shared_elements';
import {
  CSP_CAMPAIGN_DETAILS_PATH,
  DCA_CAMPAIGN_DETAILS_PATH,
  RCS_CSP_CAMPAIGN_DETAILS_PATH,
  RCS_DCA_CAMPAIGN_DETAILS_PATH,
} from '@/constants/paths';
import { RCS_CAMPAIGN_ENABLED } from '@/constants';

interface LocationState {
  goBackPage?: string;
}

interface CampaignRedirectorParams {
  id: string;
}

const CampaignRedirector: FunctionComponent = () => {
  const history = useHistory();
  const { state } = useLocation<LocationState>();
  const { id } = useParams<CampaignRedirectorParams>();

  const redirect = async () => {
    if (id) {
      const campaign = await campaignController.getCampaignDetail(id);
      const isCspCampaign = campaign?.isPrimaryDca ?? true;
      if (campaign) {
        if (RCS_CAMPAIGN_ENABLED && campaign.channelId === 'RCS') {
          history.replace(
            (isCspCampaign
              ? RCS_CSP_CAMPAIGN_DETAILS_PATH
              : RCS_DCA_CAMPAIGN_DETAILS_PATH
            ).replace(':id', id),
            state
          );
        } else {
          // Fallback to 10DLC
          history.replace(
            (isCspCampaign
              ? CSP_CAMPAIGN_DETAILS_PATH
              : DCA_CAMPAIGN_DETAILS_PATH
            ).replace(':id', id),
            state
          );
        }
      }
    }
  };

  useEffect(() => {
    redirect();
  }, [id]);

  return <Loader />;
};

export default CampaignRedirector;
